
import { projectCookieData } from '@/config/functions'
import { EDateType, EProjectStatus } from '@/helpers/enums'
import { projectDetails } from '@/helpers/project'

export default {
  name: 'ShowProject',

  props: {
    projectData: {
      type: Object,
      required: true
    },
    applicationData: {
      type: Object,
      default: () => {},
      required: false
    }
  },

  data() {
    return {
      EDateType,
      similarProjects: [],
      dialog: this.$route.query.PAQ === 'true',
      exposeAll: false,
      referralDialog: false,
      preApplicationPassed: false
    }
  },

  async fetch() {
    const { data } = await this.$api.publicProjects.getSimilarJobs(this.$route.params.id)
    this.similarProjects = data.results
  },

  computed: {
    isFreelancerActive() {
      return this.$store.state.auth.user?.isActive
    },
    talentId() {
      return this.$store.state.auth.user?.id
    },

    canApplyForProject() {
      return this.projectData?.status === EProjectStatus.ACTIVE
    },

    generateReferralLinks() {
      if (this.$auth.loggedIn && this.isFreelancerActive && !this.canApplyForProject) {
        return {
          id: 'jobShare',
          text: this.$t('talent.global.project.public.re.share'),
          showButton: true
        }
      }
      return {
        showButton: false
      }
    },

    generateLinks() {
      if (this.$auth.loggedIn) {
        if (
          this.applicationData?.multipleApplicationsAllowed &&
          this.applicationData?.previousApplications.length &&
          this.applicationData?.canApplyAgain
        ) {
          return {
            id: 'jobApply',
            url: this.$link.application(this.$route.params.id),
            text: this.$t('talent.global.project.public.re.apply'),
            showButton: true
          }
        }
        if (this.applicationData?.canApply) {
          return this.$useConfig(this.$EClientConfig.ENABLE_EXTERNAL_APP_LINK)
            ? {
                id: 'jobRedirect',
                url: this.projectData.externalApplicationLink,
                text: this.$t('talent.global.project.public.apply'),
                showButton: Boolean(this.projectData.externalApplicationLink),
                isExternalAppLink: true
              }
            : {
                id: 'jobApply',
                url: this.$link.application(this.$route.params.id),
                text: this.$t('talent.global.project.public.apply'),
                showButton: true
              }
        } else {
          return {
            showButton: false
          }
        }
      } else if (this.canApplyForProject) {
        return {
          id: 'publicJobsRegsiterToApply',
          url: this.$link.signup(),
          text: this.$t('talent.global.project.public.register'),
          showButton: true
        }
      } else {
        return {
          id: 'publicJobsRegsiter',
          url: this.$link.signup(),
          text: this.$t('talent.global.project.public.signup'),
          showButton: true
        }
      }
    },

    makeEntityBool() {
      const entityName = this.projectData?.legalEntityName?.toLowerCase()
      const exists = this.$te(`talent.global.entity.${entityName}.disclaimer`)
      const verb = this.$t(`talent.global.entity.${entityName}.disclaimer`)

      return (exists && verb !== '') || false
    },

    entityDisclaimer() {
      const entityName = this.projectData?.legalEntityName?.toLowerCase()
      return this.$t(`talent.global.entity.${entityName}.disclaimer`)
    },

    makeTitleFontSmallerOnMobile() {
      const longestWord = this.findLongestWord(this.projectData.title)
      return longestWord > 14 && this.$vuetify.breakpoint.name === 'xs'
    },

    buttonXLarge() {
      return (
        this.$vuetify.breakpoint.sm ||
        this.$vuetify.breakpoint.md ||
        this.$vuetify.breakpoint.lg ||
        this.$vuetify.breakpoint.xl
      )
    },

    projectDetails() {
      return projectDetails(this, this.projectData)
    },

    logoPath() {
      return this.$legalEntityLogo(this.projectData.legalEntityName, {
        width: 64,
        height: 64,
        fit: 'cover'
      })
    }
  },

  mounted() {
    const jobHandleIdStorage = localStorage.getItem('preApplicationPassed')

    if (jobHandleIdStorage && jobHandleIdStorage === this.projectData.id.toString()) {
      this.preApplicationPassed = true
      return
    }

    const jobHandleQuery = this.$route.query.preapplicationpassed
    if (jobHandleQuery === 'yes') {
      localStorage.setItem('preApplicationPassed', this.projectData.id.toString())
      this.preApplicationPassed = true
    }
  },

  methods: {
    async prepareProject() {
      if (!this.$auth.loggedIn && this.canApplyForProject) {
        const cookieData = projectCookieData(this.projectData)
        await this.$auth.$storage.setUniversal('projectData', cookieData, true)
      }
    },

    async saveJobData(url) {
      if (
        !this.preApplicationPassed &&
        this.projectData.preApplicationQuestions.length &&
        !this.applicationData?.canResumeApply &&
        this.canApplyForProject &&
        this.$useConfig(this.$EClientConfig.ENABLE_PAQ)
      ) {
        this.dialog = true
      } else {
        await this.prepareProject()
        this.$router.push(url)
      }
    },

    checkPreApplicationQuestions(result) {
      switch (result) {
        case 'success':
          return this.handlePreAppQuestionsSuccess()
        case 'fail-proceed':
          return this.handlePreAppQuestionsFailed()
      }
    },

    handlePreAppQuestionsFailed() {
      return this.$router.push(this.$link.projectSearch())
    },

    async handlePreAppQuestionsSuccess() {
      if (this.canApplyForProject) {
        await this.prepareProject()

        const desiredRoute = this.$auth.loggedIn
          ? this.$link.application(this.projectData.id)
          : this.$link.signup()

        return await this.$router.push(desiredRoute)
      }
    },
    findLongestWord(str) {
      const longestWord = str.split(' ').reduce(function (longest, currentWord) {
        return currentWord.length > longest.length ? currentWord : longest
      }, '')
      return longestWord.length
    },
    handleOpenReferralModal() {
      this.referralDialog = true
    }
  }
}
